import apiClient from "./apiClient";
import { BaseService } from "./baseService";
import { BookingRvDto, CreateBookingRequest, Doctor } from "../types/BookingRv";

class BookingRvService extends BaseService<BookingRvDto, CreateBookingRequest> {
  constructor() {
    // ΔΙΟΡΘΩΣΗ: Αφαιρούμε το "/api" γιατί υπάρχει ήδη στον apiClient
    super("/doctors");
  }

  // 1. Φόρτωση γιατρών (GET /api/doctors)
  async getDoctors(): Promise<Doctor[]> {
    return (await apiClient.get<Doctor[]>(this.url)) as unknown as Doctor[];
  }

  // 2. Φόρτωση διαθέσιμων slots (GET /api/doctors/{id}/available-slots?date=...)
  async getAvailableSlots(
    doctorId: string | number,
    date: string,
  ): Promise<string[]> {
    return (await apiClient.get<string[]>(
      `${this.url}/${doctorId}/available-slots`,
      {
        params: { date },
      },
    )) as unknown as string[];
  }

  // 3. Δημιουργία ραντεβού (POST /api/doctors/booking)
  async createBooking(
    bookingData: CreateBookingRequest,
  ): Promise<BookingRvDto> {
    return (await apiClient.post<BookingRvDto>(
      `${this.url}/booking`,
      bookingData,
    )) as unknown as BookingRvDto;
  }
}

export const bookingRvService = new BookingRvService();
